import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { csvUrl, getData} from '../CustomUtils'
import { BORDEREAUX_REPORT_QUERY } from '../../../graphql.js'
import ResultsGrid from '../ResultsGrid.js'
import ColumnHeadings from '../ColumnHeadings.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'

const BORDEREAUX_REPORT = gql(BORDEREAUX_REPORT_QUERY)

export default function BordereauxReportDetails({ location }) {
  console.log('BordereauxReportDetails rendered')

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, BORDEREAUX_REPORT, 'bordereauxReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    let resultRows = ResultsGrid(results, 0)
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Bisc/bordereauxReport/bordereaux', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', margin: 'auto', minWidth: '600px'}} >
          <ReportHeading title={'Bordereaux Report'} widths={['0%', '50%', '50%']} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}